import { Injectable } from '@angular/core';
import { BehaviorSubject } from "rxjs";
import {
  CompaniesSelectorDto,
} from "../../pp/component/shared/company-with-logo-description/company-with-logo-description.component";
import { AllRounds } from "./RoundComponentCalculation";
import { Company } from '../../pp/dto/Company';

/**
 * Service to manage shared state between all children of {@link CompanyPerformanceComponent}.
 *
 * This service acts as a state manager for data that needs to be shared and accessed across
 * multiple components within the {@link CompanyPerformanceComponent}. The general flow is as follows:
 * - `CompanyPerformanceComponent` initializes the data on its initialization.
 * - The data is then shared with its child components via observables provided by this service.
 * - Child components subscribe to these observables to access the shared values.
 */
@Injectable({
  providedIn: 'root',
})
export class CompanyPerformanceService {
  private companiesDataSubject = new BehaviorSubject<CompaniesSelectorDto>(null);
  private roundsSubject = new BehaviorSubject<AllRounds>(null);
  companiesData$ = this.companiesDataSubject.asObservable();
  rounds$ = this.roundsSubject.asObservable();


  setRounds(rounds: AllRounds): void {
    this.roundsSubject.next(rounds);
  }

  setCompaniesData(companiesData: CompaniesSelectorDto): void {
    this.companiesDataSubject.next(companiesData);
  }

  getSelectedCompany(): Company {
    return this.companiesDataSubject.value?.selectedCompany;
  }
}
